//!
//! NOTE: don't change the string or its case. Trading View component theme depends on it.
export enum ETheme {
  LIGHT = 'Light',
  DARK = 'Dark',
}
